import { useEffect, useState } from "react";
import { api, fmtINR } from "../../lib/api";
import { PageHeader } from "../../components/Layout";
import { StatusBadge } from "../../components/StatusBadge";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { ListChecks, Clock, CheckCircle, CurrencyInr, PlusCircle } from "@phosphor-icons/react";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <Card className="rounded-sm p-6 border-border" data-testid={`cstat-${label.toLowerCase().replace(/ /g, "-")}`}>
    <div className="flex items-start justify-between">
      <div><p className="label-caps">{label}</p><p className="font-heading text-3xl font-bold mt-2">{value}</p></div>
      <div className={`w-10 h-10 rounded-sm flex items-center justify-center ${accent}`}><Icon size={20} weight="bold" /></div>
    </div>
  </Card>
);

export default function CustomerDashboard() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/customer/dashboard").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="p-8 text-muted-foreground">Loading…</div>;

  return (
    <>
      <PageHeader title={`Hi, ${d.customer.name}`} subtitle="Your services at a glance"
        actions={<Button className="rounded-sm gap-2" onClick={() => navigate("/account/new")} data-testid="book-service-btn"><PlusCircle size={16} weight="bold" /> Book Service</Button>} />
      <div className="p-8 space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
          <Stat icon={ListChecks} label="Total Requests" value={d.total_requests} accent="bg-blue-100 text-blue-700" />
          <Stat icon={Clock} label="Open" value={d.open_requests} accent="bg-amber-100 text-amber-700" />
          <Stat icon={CheckCircle} label="Completed" value={d.completed} accent="bg-green-100 text-green-700" />
          <Stat icon={CurrencyInr} label="Total Spent" value={fmtINR(d.total_spent)} accent="bg-violet-100 text-violet-700" />
        </div>
        <Card className="rounded-sm border-border">
          <div className="px-6 py-4 border-b border-border flex items-center justify-between">
            <h3 className="font-heading font-semibold">Recent Requests</h3>
            <Button variant="ghost" size="sm" className="rounded-sm" onClick={() => navigate("/account/requests")} data-testid="view-all-requests">View all</Button>
          </div>
          <div className="divide-y divide-border" data-testid="recent-requests">
            {d.recent.length === 0 && <p className="px-6 py-8 text-center text-sm text-muted-foreground">No requests yet — book your first service!</p>}
            {d.recent.map((j) => (
              <div key={j.id} className="px-6 py-3 flex items-center justify-between text-sm">
                <div>
                  <p className="font-semibold">{j.service_type} · {j.product_category}</p>
                  <p className="text-xs text-muted-foreground">{j.scheduled_date || "—"} {j.partner_name && `· ${j.partner_name}`}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="font-mono">{fmtINR(j.amount)}</span>
                  <StatusBadge value={j.status} />
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </>
  );
}
